import React from "react";
import { ProductBadge } from "src/components/Common/ProductBadge/ProductBadge";
import useProductInfo from "src/mocks/useProductInfo";
import styles from "./index.module.scss";
import { localStrings } from "src/utils/localization";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
import { promotionPayPage } from "src/config/config";

const ProductCard: React.FC = () => {
  const { product, cardInfo } = useProductInfo();
  const { name, icon, badge, moreInfoUrl, word } = product || {};
  const { description, subTitle, features } = cardInfo || {};
  const { currentPath } = useRouter();
  const isShowProductCard = !promotionPayPage.includes(currentPath);
  const handleOpenMore = (url: string) => {
    if (url && url !== "#") {
      window.open(url, "_blank");
    }
  };
  const { lang } = useRouter();
  const isKorean = lang === "ko";
  const { t } = useTranslation();
  return (
    <div style={{ display: `${isShowProductCard ? "block" : "none"}` }}>
      <div className={styles.productCard}>
        <div className={styles.productHeader}>
          <div className={styles.productIcon}>
            <div className={styles.iconCircle}>
              <img src={icon} alt={name} className={styles.logoImage} />
            </div>
          </div>
          <div className={styles.productTitle}>
            <div className={styles.titleRow}>
              <h2 className={styles.productName}>{name}</h2>
              {badge && badge?.length > 0 && (
                <div className={styles.tagsContainer}>
                  {/* {isRequired && (
                  <div className="requiredTag">
                    <span>필수</span>
                  </div>
                )} */}
                  {badge?.map((tag, index) => (
                    <ProductBadge key={index} type={tag} />
                  ))}
                </div>
              )}
            </div>
            <p className={styles.productSubtitle}>{word}</p>
          </div>
        </div>

        <div
          className={`${styles.productDescription} ${
            isKorean ? styles.ko : styles.en
          }`}
        >
          {description?.map((paragraph, index) => {
            if (paragraph === "#") {
              return null;
            }
            return <p key={index}>{paragraph}</p>;
          })}

          {features?.length > 0 && (
            <div className={styles.featuresSection}>
              <p className={styles.featuresTitle}>
                {t("home.productInfo.features")}
              </p>
              <ul className={styles.featuresList}>
                {features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {moreInfoUrl && moreInfoUrl?.length > 0 && (
          <div className={styles.productButton}>
            {moreInfoUrl.map((url) => (
              <button
                key={url.url}
                className={styles.learnMoreButton}
                onClick={() => handleOpenMore(url.url)}
                disabled={url.url === "#"}
              >
                {url.label}
              </button>
            ))}
          </div>
        )}

        {/* <div className={styles.productButton}>
          <button
            className={styles.learnMoreButton}
            onClick={() => handleOpenMore(moreInfoUrl || "")}
            disabled={moreInfoUrl === "#"}
          >
            {t("home.productInfo.btn.learnMore")}
          </button>
        </div>
        {startNowUrl && (
          <div className={styles.productButton}>
            <button
              className={styles.learnMoreButton}
              onClick={() => handleOpenMore(startNowUrl)}
              disabled={startNowUrl === "#"}
            >
              {t("home.productInfo.btn.startNow")}
            </button>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ProductCard;
